import { render, staticRenderFns } from "./merhantChild.vue?vue&type=template&id=1745f821&scoped=true&"
import script from "./merhantChild.vue?vue&type=script&lang=js&"
export * from "./merhantChild.vue?vue&type=script&lang=js&"
import style0 from "./merhantChild.vue?vue&type=style&index=0&id=1745f821&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1745f821",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1745f821')) {
      api.createRecord('1745f821', component.options)
    } else {
      api.reload('1745f821', component.options)
    }
    module.hot.accept("./merhantChild.vue?vue&type=template&id=1745f821&scoped=true&", function () {
      api.rerender('1745f821', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/merhantChild.vue"
export default component.exports